@let message = toast().message;
@let status = toast().status;
@let icon = toast().icon;
@let duration = toast().duration;

<!-- TOAST -->
<div class="toast" [class.toast--warning]="status === 'warning'" [class.toast--error]="status === 'error'"
    [class.toast--success]="status === 'success'" [class.toast--info]="status === 'info'">
    @if (duration > 0) {
    <div class="toast__duration-indicator" [style.animationDuration]="duration + 'ms'"></div>
    }
    <mat-icon class="toast__status__icon" [svgIcon]="icon" />
    <p class="toast__message" [innerHTML]="message | safe: 'html'"></p>
    <button matRipple class="toast__dismiss-button" (click)="dismissed.emit()">
        <mat-icon [svgIcon]="'x'" />
    </button>
</div> <!-- /toast -->